export default __webpack_public_path__ + "static/media/IMG0089.9e699a77.jpg";